<template>
  <SideMenu
    ref="sideMenu"
    :heading="$lang('checkout', 'voucher_heading')"
    :side="'right'"
    @on-side-menu-close="$emit('onVoucherMenuClose')"
  >
    <div class="p-24">
      <TextInput
        :placeholder="$lang('checkout', 'voucher_placeholder')"
        :has-error="voucherStatus === LoadingStatuses.ERROR"
        :icon="voucherStatus === LoadingStatuses.SUCCESS ? 'check' : ''"
        :icon-style="'far'"
        :border-color="'#979D95'"
        :icon-color="'#505A4B'"
        :is-loading="voucherStatus === LoadingStatuses.LOADING"
        @submit-input="(input) => voucher = input"
      />
      <div
        v-if="voucherStatus === LoadingStatuses.ERROR"
        class="text-xxs text-warning mt-12"
      >
        {{ $lang('checkout', 'voucher_error') }}
      </div>
      <ButtonComponent
        class="mt-12"
        is-large-btn
        is-block
        :text="$lang('checkout', 'voucher_select_btn')"
        @click="applyVoucher"
      />
    </div>
  </SideMenu>
</template>

<script setup lang="ts">
import ButtonComponent from '~/components/forms/ButtonComponent.vue';
import SideMenu from '~/components/navigation/SideMenu.vue';
import TextInput from '~/components/forms/TextInput.vue';
import LoadingStatuses from '~/constants/loading-statuses';
import { useCartStore } from '~/store/cart';
import type { CartType } from '~/constants/types/cart';
const { centraPost } = useApiFetch();
const cartStore = useCartStore();

const emit = defineEmits<{
  (e: 'onVoucherMenuClose'): void;
  (e: 'suspendKco'): void;
  (e: 'resumeKco'): void;
  (e: 'voucherApplied'): void;
}>();

const voucherCode = ref('');
const voucher = ref('');
const voucherStatus = ref('');

const sideMenu = ref<typeof SideMenu | null>(null);
onMounted(()=> {
  if (sideMenu.value) {
    sideMenu.value.openOverlay();
  }
});

const applyVoucher = async() => {
  voucherStatus.value = LoadingStatuses.LOADING;
  emit('suspendKco');

  if (!voucher) {
    voucherStatus.value = '';
  } else {
    const res = await centraPost<CartType>('/vouchers', {
      voucher: voucher.value,
    });
    if (res) {
      cartStore._cartData = res;
      emit('voucherApplied');
    } else {
      setTimeout(() => {
        voucherStatus.value = LoadingStatuses.ERROR;
      }, 1000);
    }
  }
  emit('resumeKco');
};

</script>
